import { createReducer, on } from "@ngrx/store";
import { InitialBaseState } from "../states/static.state";
import { userLoginAction } from "../actions/static.actions";

export const staticReducer = createReducer(
    InitialBaseState,
    on(userLoginAction.loadUserLogin, (state, { status, data, error }) => {
      switch (status) {
        case 'request':
          return { ...state, success: false, statusCode: '', loading: true };
        case 'success':
          return { ...state, userData: data, success: true, statusCode: 'login Success', loading: false };
        case 'failure':
          return { ...state, success: false, statusCode: 'login Failed', loading: false };
        default:
          return state;
      }
    }),
  );
  